<!-- 盘点历史 -->

<template>
    <div class="reward">
        <div class="tableConBox">
            <div class="tableTem" @click="searchList=[]">
                <div class="HSpace1"></div>
                <div class="searchBox flex flex-align-center">
                    <div class="searchCon clearfix">
                        <div class="left change-type">
                            <span @click="nowType='bar'">网吧评价</span>
                            <span :class="nowType=='bar'?'type-wrap':'type-wrap to-right'" @click="nowType=='bar'?nowType='emp':nowType='bar'">
                                <i @click.stop=""></i>
                            </span>
                            <span @click="nowType='emp'">员工评价</span>
                        </div>
                        <div class="left monthBox clearfix">
                            <!-- <div class="left" @click="cutMonth(0)">上一月</div> -->
                            <el-date-picker
                                class="left"
                                v-model="yearMonth"
                                :picker-options="pickerOptions0"
                                type="month"
                                @change="cutDataFn"
                                placeholder="选择月">
                            </el-date-picker>
                            <!-- <div class="left" @click="cutMonth(1)">下一月</div> -->
                        </div>
                        <!-- <div class="left emp-name clearfix" v-if="nowType!='bar'"> -->
                        <!-- <div class="left emp-name clearfix"> -->
                            <!-- <input type="text" v-model="empName" placeholder="请输入员工姓名" />
                            <div class="emp-list" v-if="empNameData.length">
                                <ul>
                                    <li @click="nowEmpId = item[0];empNameData=[];empName=item[1];nowEmpName=item[1]" v-for="(item,index) in empNameData" :key="index">
                                        {{item[1]}}
                                    </li>
                                </ul>
                            </div> -->
                        <!-- </div> -->
                        <div class="left emp-name" v-if="nowType!='bar'">
                            <el-select v-model="nowEmpId" placeholder="请选择员工">
                                <el-option
                                :key="0"
                                :label="'全部'"
                                :value="''">
                                </el-option>
                                <el-option
                                v-for="item in empNameData"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                                </el-option>
                            </el-select>
                        </div>
                        <div class="search">
                            <button @click="search">查询</button>
                        </div>
                    </div>
                </div>
                <div class="HSpace2"></div>
                <div class="tableBox">
                    <div class="tableBoxScroll">
                        <table class="titleTable">
                            <tr v-if="nowType=='bar'">
                                <th style="width:10%">序号</th>
                                <th style="width:10%">服务</th>
                                <th style="width:10%">流畅度</th>
                                <th style="width:10%">卫生情况</th>
                                <th style="width:10%">空气质量</th>
                                <th style="width:10%">桌椅舒适度</th>
                                <th style="width:10%">设备满意度</th>
                                <th style="width:10%">桌号</th>
                                <th style="width:10%">留言</th>
                                <th style="width:10%">评价时间</th>
                            </tr>
                            <tr v-else>
                                <th style="width:10%">序号</th>
                                <th style="width:18%">员工姓名</th>
                                <th style="width:18%">满意度</th>
                                <th style="width:18%">桌号</th>
                                <th style="width:10%">留言</th>
                                <th style="width:26%">评价时间</th>
                            </tr>
                        </table>
                        <div class="scrollBox" v-if="nowType=='bar'">
                            <div class="scroll">
                                <table class="conTable" :class="{overLengthTable:ratingData.length>10}" v-if="ratingData.length>0">
                                    <tr v-for="(item,ind) in ratingData" :key="ind">
                                        <td style="width:10%">
                                            <span v-text="1+ind+(pageForBar-1)*size"></span>
                                        </td>
                                        <td style="width:10%;">{{rating[item.netService]}}</td>
                                        <td style="width:10%;">{{rating[item.netFluency]}}</td>
                                        <td style="width:10%;">{{rating[item.healthConditions]}}</td>
                                        <td style="width:10%;">{{rating[item.airQuality]}}</td>
                                        <td style="width:10%;">{{rating[item.comfort]}}</td>
                                        <td style="width:10%;">{{rating[item.equipment]}}</td>
                                        <td style="width:10%;">{{decodeURI(item.tableNo)}}</td>
                                        <td style="width:10%;cursor: pointer;color:blue;" v-if="item.message" @click="showText(item)">查看留言</td>
                                        <td style="width:10%;" v-if="!item.message">暂无留言</td>
                                        <td style="width:10%;">{{item.appraiseTime | dateForGradePage}}</td>
                                    </tr>
                                </table>
                                <div class="no-data" v-else>
                                    暂无记录
                                </div>
                            </div>
                        </div>
                        <div class="tableBox scrollBox tableBox-for-emp" v-if="nowType=='emp'">
                            <div class="scroll">
                                <table class="conTable" :class="{overLengthTable:ratingDataForEmp.length>10}" v-if="ratingDataForEmp.length>0">
                                    <tr v-for="(item,ind) in ratingDataForEmp" :key="ind">
                                        <td style="width:10%">
                                            <span v-text="1+ind+(pageForEmp-1)*size"></span>
                                        </td>
                                        <td style="width:18%;">{{item.empName}}</td>
                                        <td style="width:18%;">{{rating[item.appraise]}}</td>
                                        <td style="width:18%;">{{decodeURI(item.tableNo)}}</td>
                                        <td style="width:10%;cursor: pointer;color:blue;" v-if="item.message" @click="showText(item)">查看留言</td>
                                        <td style="width:10%;" v-if="!item.message">暂无留言</td>
                                        <td style="width:26%;">{{item.appraiseTime | dateForGradePage}}</td>
                                    </tr>
                                </table>
                                <div class="no-data" v-else>
                                    暂无记录，请点击查询或者重新选择查询条件。
                                </div>
                            </div>
                        </div>
                    </div>
                    <el-dialog title="留言" :visible.sync="centerDialogVisible" width="30%" center>
                        <span>{{nowText}}</span>
                        <span slot="footer" class="dialog-footer">
                            <el-button @click="centerDialogVisible = false">取 消</el-button>
                            <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
                        </span>
                    </el-dialog>
                </div>
                <!-- 分页器 -->
                <div class="pager flex flex-align-center" v-if="nowType=='bar'">
                    <div class="pagerCon clearfix">
                        <span class="right">
                            <el-pagination background layout="prev, pager, next" :page-size="size" :total="totalElementsForBar" :current-page.sync="pageForBar" @current-change="handleCurrentChange">
                            </el-pagination>
                        </span>
                    </div>
                </div>
                <div class="pager flex flex-align-center" v-if="nowType=='emp'">
                    <div class="pagerCon clearfix">
                        <span class="right">
                            <el-pagination background layout="prev, pager, next" :page-size="size" :total="totalElementsForEmp" :current-page.sync="pageForEmp" @current-change="handleCurrentChangeForEmp">
                            </el-pagination>
                        </span>
                    </div>
                </div>

            </div>
        </div>
        <table id="scrollBox" style="display:none">
        </table>

    </div>
</template>

<script type="text/javascript">
import { url } from "@/router/url.js";
export default {
  props: ["curStoreId", "pageSize"],
  data() {
    return {
    nowEmpName:'',
    nowEmpId:"",
    empName:"",
    empNameData:[],
    typeMonth:false,
    pickerOptions0: {
        //时间禁用,今天以后的时间禁用。
        disabledDate(time) {
            return time.getTime() > Date.now() || time.getTime() < (new Date('2017,01,01')).getTime();
        }
    },
      yearMonth:'',//年月
      nowType: "bar", //当前查询方式
      getBtn: true, // 控制翻页请求
      size: 15,
      ratingData: [], //评价记录
      ratingDataForEmp: [], //员工的评价记录
      rating: {
        VERY_GOOD: "非常满意",
        GOOD: "满意",
        BAD: "不满意"
      },
      pageForBar: 1,
      pageForEmp: 1,
      totalElementsForBar: 0,
      totalElementsForEmp: 0,
      centerDialogVisible: false,
      nowText:"",
    };
  },
  watch: {
    //   empName(val){
    //       if(!val){
    //           this.empNameData = [];
    //           this.nowEmpId = "";
    //           return;
    //       }
    //       if(this.nowEmpName == val){
    //           this.empNameData = [];
    //           return;
    //       }
    //       this.$http({
    //           url:"find-emp",
    //           method:"GET",
    //           params:{
    //               storeId:this.curStoreId,
    //               name:val
    //           }
    //       }).then(res=>{
    //           this.empNameData = res.data;
    //       });
    //   },
    nowType(val) {
        this.typeMonth = false;
      if (val == "bar") {
        this.getRatingData(this.pageForBar - 1);
      } else {
        this.getRatingDataForEmp(this.pageForEmp - 1);
      }
    }
  },
  methods: {
    search(){
        if(!this.yearMonth){
            this.$message({
                message: '请选择月份',
                customClass: 'error'
            })
            return ;
        }
       if(this.nowType == "bar"){
           
           this.typeMonth = true;
            this.yearMonth = new Date(this.yearMonth).Format("yyyy-MM");//给日期插件赋值为选择时间
            let year = this.yearMonth.split('-')[0];//选择的年
            let month = this.yearMonth.split('-')[1];//选则的月
            
            // 
            let timeStr = new Date(this.yearMonth+"-01").getTime() + "-" + new Date(this.yearMonth+"-01").getTime();
            let nowTime = new Date().getTime();
            if(!(this.$canClickSelect("ratingInfoBar",timeStr,nowTime))){
                this.$message({
                    message: '5秒内禁止重复查询相同数据',
                    customClass: 'error'
                });
                return;
            }
            //


            this.getRatingDataByMonth(0,year,month);
       }else{
           this.typeMonth = true;
            this.yearMonth = new Date(this.yearMonth).Format("yyyy-MM");//给日期插件赋值为选择时间
            let year = this.yearMonth.split('-')[0];//选择的年
            let month = this.yearMonth.split('-')[1];//选则的月
            
            if(this.nowEmpId){
                // 
                let timeStr = new Date(this.yearMonth+"-01").getTime() + "-"+this.nowEmpId+"-" + new Date(this.yearMonth+"-01").getTime();
                let nowTime = new Date().getTime();
                if(!(this.$canClickSelect("ratingInfoEmp",timeStr,nowTime))){
                    this.$message({
                        message: '5秒内禁止重复查询相同数据',
                        customClass: 'error'
                    });
                    return;
                }
                //
                this.getRatingDataForEmpByMonth(0,year,month,this.nowEmpId);
            }else{
                // 
                let timeStr = new Date(this.yearMonth+"-01").getTime() + "-" + new Date(this.yearMonth+"-01").getTime();
                let nowTime = new Date().getTime();
                if(!(this.$canClickSelect("ratingInfoEmp",timeStr,nowTime))){
                    this.$message({
                        message: '5秒内禁止重复查询相同数据',
                        customClass: 'error'
                    });
                    return;
                }
                //
                this.getRatingDataForEmpByMonth(0,year,month);
            }
       }
    },
      //日历插件 
    cutDataFn(){
        // console.log(this.yearMonth)
        
        this.yearMonth = new Date(this.yearMonth).Format("yyyy-MM");
    },
    showText(item) {
      this.nowText = item.message ? item.message : "暂无留言";
      this.centerDialogVisible = true;
    },
    handleCurrentChange(val) {
        if(this.typeMonth){
            this.yearMonth = new Date(this.yearMonth).Format("yyyy-MM");//给日期插件赋值为选择时间
            let year = this.yearMonth.split('-')[0];//选择的年
            let month = this.yearMonth.split('-')[1];//选则的月
            this.getRatingDataByMonth(val - 1,year,month);
            this.pageForBar = val;
        }else{
            this.getRatingData(val - 1);
            this.pageForBar = val;
        }
      
    },
    handleCurrentChangeForEmp(val) {
        if(this.typeMonth){
            this.yearMonth = new Date(this.yearMonth).Format("yyyy-MM");//给日期插件赋值为选择时间
            let year = this.yearMonth.split('-')[0];//选择的年
            let month = this.yearMonth.split('-')[1];//选则的月
            if(this.nowEmpId){
                this.getRatingDataForEmpByMonth(val - 1,year,month,this.nowEmpId);
            }else{
                this.getRatingDataForEmpByMonth(val - 1,year,month);
            }
        }else{
             this.getRatingDataForEmp(val - 1);
             this.pageForEmp = val;
        }
     
    },
    getRatingData(page) {
      this.$http({
        url: "get-netApp",
        method: "GET",
        params: {
          storeId: this.curStoreId,
          page,
          size: this.size
        }
      }).then(res => {
        console.log(res);
        this.ratingData = res.data.content;
        this.totalElementsForBar = res.data.totalElements;
      });
    },
    getRatingDataByMonth(page,year,month) {
      this.$http({
        url: "get-netApp",
        method: "GET",
        params: {
          storeId: this.curStoreId,
          page,
          size: this.size,
          year,
          month,
          type:"MONTH"
        }
      }).then(res => {
        console.log(res);
        this.ratingData = res.data.content;
        this.totalElementsForBar = res.data.totalElements;
      });
    },
    getRatingDataForEmp(page) {
      this.$http({
        url: "get-empApp",
        method: "GET",
        params: {
          storeId: this.curStoreId,
          page,
          size: this.size
        }
      }).then(res => {
        console.log(res);
        this.ratingDataForEmp = res.data.content;
        this.totalElementsForEmp = res.data.totalElements;
      });
    },
    getRatingDataForEmpByMonth(page,year,month,empId="") {
      this.$http({
        url: "get-empApp",
        method: "GET",
        params: {
          storeId: this.curStoreId,
          page,
          size: this.size,
          year,
          month,
          empId,
          type:"MONTH"
        }
      }).then(res => {
        console.log(res);
        this.ratingDataForEmp = res.data.content;
        this.totalElementsForEmp = res.data.totalElements;
      });
    },
    getEmp(){
        this.$http({
                url:"find-emp",
                method:"GET",
                params:{
                    storeId:this.curStoreId,
                }
            }).then(res=>{
                this.empNameData = res.data;
            });
    }
  },
  activated: function() {
    this.getRatingData(0);
    this.getEmp();
  }
};
</script>
<style lang="scss">
@import "../../../../../static/css/common.scss";
@import "../../../tableTemplate/tableTem.scss";
@import "./ratingInfo.scss";
</style>



// WEBPACK FOOTER //
// ratingInfo.vue?62c6b72a